const BLOOD_TYPES = {
    A_POSITIVE: 'A+',
    A_NEGATIVE: 'A-',
    B_POSITIVE: 'B+',
    B_NEGATIVE: 'B-',
    AB_POSITIVE: 'AB+',
    AB_NEGATIVE: 'AB-',
    O_POSITIVE: 'O+',
    O_NEGATIVE: 'O-',
}

const BLOOD_TYPES_ITEMS = Object.entries(BLOOD_TYPES).map((e) => { return {id: e[1], name: e[1]} })

export {
    BLOOD_TYPES,
    BLOOD_TYPES_ITEMS
};